<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6">
                    <card>
                        <h4 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h4>
                        <form>
                            <div class="loader" v-if="waiting"></div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="premium-control"
                                               class="control-label label-checkbox">Премиум</label>
                                        <input v-model="object.is_premium" id="premium-control"
                                               class="form-check-inline" type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Категория</label>
                                        <select v-model="object.category_id"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-if="c.id !== 999" v-for="c in categories" v-bind:value="c.id">
                                                {{ c.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="Название"
                                              v-model="object.name"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="object.status"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Активен</option>
                                            <option value="0">Не активен</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Метод наложения</label>
                                        <select v-model="object.params.mode"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value=0>Normal</option>
                                            <option value=1>Add</option>
                                            <option value=3>Multiply</option>
                                            <option value=4>Screen</option>
                                            <option value=5>Overlay</option>
                                            <option value=7>Lighten</option>
                                            <option value=10>HardLight</option>
                                            <option value=11>SoftLight</option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="Прозрачность по умолчанию (от 1 до 0)"
                                              v-model="object.params.opacity"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Максимальная прозрачность (по умолчанию 1)"
                                              v-model="object.params.max_opacity"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Сортировка (чем больше, тем выше в списке)"
                                              v-model="object.sort"
                                              placeholder="">
                                    </fg-input>

                                </div>
                                <div class="col-md-6 buttons-block">
                                    <h4 slot="header" class="card-title">
                                        Эффект: <span v-if="object.src">
                                            <span class="inline-link">
                                                <span v-if="object.src_size >= 1"
                                                      class="bg-danger">{{ object.src_size }}Mb</span>
                                                <span v-else-if="object.src_size >= 0.5"
                                                      class="bg-warning">{{ object.src_size }}Mb</span>
                                                <span v-else>{{ object.src_size }}Mb</span>
                                                <a :href="object.src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                    </h4>

                                    <img @click.prevent="openResource(eobject.src_full)"
                                         :src="object.src_full" class="device-block device1">

                                    <div>
                                        <input ref="srcFileInput" class="btn-file" type="file"
                                               @change="uploadFile($event, 'src')">
                                        <button type="button" class="btn btn-info btn-fill upload-button"
                                                @click="$refs.srcFileInput.click()">
                                            Загрузить
                                        </button>
                                        <div class="clearfix"></div>
                                    </div>

                                    <h4 slot="header" class="card-title" style="margin-top: 30px">
                                        Превью (jpg): <span v-if="object.preview_src">
                                            <span class="inline-link">
                                                <span v-if="object.preview_src_size >= 0.1"
                                                      class="bg-danger">{{ object.preview_src_size }}Mb</span>
                                                <span v-else-if="object.preview_src_size >= 0.05"
                                                      class="bg-warning">{{ object.preview_src_size }}Mb</span>
                                                <span v-else>{{ object.preview_src_size }}Mb</span>
                                                <a :href="object.preview_src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                    </h4>

                                    <img @click.prevent="openResource(object.preview_src_full)"
                                         :src="object.preview_src_full" class="device-block device1">

                                    <div>
                                        <input ref="previewSrcFileInput" class="btn-file" type="file"
                                               @change="uploadFile($event, 'preview_src')">
                                        <button type="button" class="btn btn-info btn-fill upload-button"
                                                @click="$refs.previewSrcFileInput.click()">
                                            Загрузить
                                        </button>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        :disabled="!object.sort || !object.category_id || !object.src"
                                        @click.prevent="save">
                                    Сохранить
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import Card from 'src/components/UIComponents/Cards/Card.vue'

    export default {
        name: 'CreateEffect',
        components: {
            Card,
        },
        data() {
            return {
                id: null,
                token: localStorage.getItem('token'),
                waiting: false,
                object: {
                    status: 0,
                    category_id: 0,
                    name: null,
                    src: null,
                    src_full: null,
                    preview_src: null,
                    preview_src_full: null,
                    is_premium: 0,
                    sort: 1,
                    params: {
                        mode: 0,
                        opacity: 1,
                        max_opacity: null
                    }
                },
                categories: [],
            }
        },
        created: function () {
            this.getCategories();
        },
        computed: {
            graphicsUrl() {
                return this.$graphicsUrl
            },
        },
        methods: {
            goBack: function () {
                this.$router.push('/effects');
            },
            getCategories: function () {
                let self = this;

                axios.get(
                    `${this.$hostname}/admin/effects/categories`,
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        }
                    })
                    .then(function (response) {
                        self.categories = JSON.parse(JSON.stringify(response.data));
                    })
                    .catch(function (error) {

                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })
                    });
            },
            save: function () {
                let self = this;

                let object = JSON.parse(JSON.stringify(this.object));
                object.params.mode = parseInt(object.params.mode);
                object.params.opacity = parseFloat(object.params.opacity);
                object.params.max_opacity = parseFloat(object.params.max_opacity);

                self.waiting = true;

                axios.post(
                    `${this.$hostname}/admin/effects/create`,
                    object,
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        }
                    })
                    .then(function (response) {

                        const notification = {
                            template: `<span><b>Эффект был успешно добавлен</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-explore-2',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'info'
                            })

                        self.waiting = false;

                        //self.$router.push('/effects');
                    })
                    .catch(function (error) {
                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })

                        self.waiting = false;

                    });
            },
            uploadFile: function (event, type) {
                let self = this;

                let formData = new FormData();

                self.waiting = true;

                formData.append('file', event.target.files[0]);

                axios.post(
                    `${this.$hostname}/admin/services/file/upload`,
                    formData,
                    {
                        params: {
                            file_type: type
                        },
                        headers: {
                            'Authorization': 'Bearer ' + this.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function (response) {

                    self.waiting = false;

                    let data = JSON.parse(JSON.stringify(response.data));

                    self.object[type] = data.url;
                    self.object[type + '_full'] = data.url_full;
                    self.object[type + '_size'] = data.filesize;

                })
                    .catch(function (error) {
                        self.waiting = false;
                        console.log(error);
                    });
            },
            openResource: function(url) {
                window.open(url, "_blank");
            }
        }
    }

</script>
<style scoped>
button:disabled,
button[disabled] {
    cursor: not-allowed;
}

.btn-save {
    width: 150px;
}

.buttons-block {
    padding-left: 20px !important;
}
.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 5px;
}
.checkbox-block {
    margin-top: 40px;
    margin-left: 40px;
}

.btn-file {
    display: none;
}

.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
}

.label-checkbox {
    margin-right: 10px
}
.inline-link span {
    padding: 3px;
    border-radius: 4px;
    font-size: 18px;
}

.bg-danger {
    background-color: rgba(255, 70, 50, 0.5) !important;
}
.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    /*margin-top: 15px;*/
}

/* Customize the label (the container) */
.container {
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 12px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #ccc;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
    opacity: 0.8;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
    background-color: #54abfe;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

.preview-device {
    display: inline-block;
    width: 32%;
    margin-left: 10px;
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.device-block.inactive {
    opacity: 0.5;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device1 {
    display: block;
    max-width: 100%;
    max-height: 100px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    background-color: transparent;
    margin-top: 15px;
    margin-bottom: 15px;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Effects/Create.vue